module.exports = __webpack_public_path__ + "static/img/design-4.2d3d1143.png";